<script lang="ts">
  import Star from '~/icons/Star.svelte';

  type Props = {
    stars: number;
    fullClear: boolean;
  };
  const props: Props = $props();
</script>

<div class="star-container">
  {#each Array.from({ length: 4 }) as star, i}
    <Star
      size="0.75em"
      class={'star ' +
        (i < props.stars
          ? props.fullClear && i === props.stars - 1
            ? 'green'
            : 'yellow'
          : 'grey')}
      outlined
    />
  {/each}
</div>

<style lang="scss">
  @use '~/theme/include-media' as *;

  .star-container {
    margin-left: -0.1em;
    display: flex;
    justify-content: center;
    :global(svg) {
      margin-right: -0.1em;
    }

    @include media('<=500px') {
      margin-left: -0.4em;
      :global(.star) {
        margin-right: -0.4em;
      }
    }
  }
</style>
